import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LayerSwitcherService } from '../layerswitcher.service';
import { BaseLayerService } from './baselayer.service';
import { FlcBaseLayer } from '../flc-base-layer.model';

@Component({
  selector: 'app-baselayer-dropdown',
  templateUrl: './baselayer-dropdown.component.html',
  styleUrls: ['./baselayer-dropdown.component.css']
})
export class BaselayerDropdownComponent implements OnInit, OnDestroy {

  baseLayers: FlcBaseLayer[] = [];

  subscription: Subscription;
  setBaselayerSubscription: Subscription;
  blForm: UntypedFormGroup;

  constructor(private blService: BaseLayerService, private fb: UntypedFormBuilder,
    private layerSwitcherService: LayerSwitcherService) { }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.setBaselayerSubscription) this.setBaselayerSubscription.unsubscribe();
  }

  ngOnInit() {
    this.blForm = this.fb.group({
      bl: [this.baseLayers[0]]
    });

    this.setBaselayerSubscription = this.blService.setBaseLayer.subscribe((baseLayer) =>{
      this.onSelectById(baseLayer);
    });

    this.subscription = this.blService.baseLayersFilled.subscribe(
      (baseLayers: FlcBaseLayer[]) => {
        this.baseLayers = baseLayers.slice();
        this.blService.setPreSelectedBaseLayer(this.layerSwitcherService.selectedBaseLayer ?
          this.layerSwitcherService.selectedBaseLayer : new FlcBaseLayer("OSM", 10, 16));
      }
    );

    this.blService.findByProfileId();
  }


  onSelectById(baseLayer: FlcBaseLayer) {
    if (baseLayer !==  null)
    {
      this.blForm.controls['bl'].setValue( baseLayer.title );
    }
    else
    {
      this.blForm.controls['bl'].setValue( '' );
    }
  }

  listenerBaseLayerSelect(baseLayer: FlcBaseLayer, event: any){
    if (event.isUserInput) {
      //moet op deze manier omdat anders 2x uitgevoerd
      this.blService.setBaseLayerSelected(baseLayer);
    }
  }

}

